import React, { useState, useEffect } from "react";
import { ProfileView } from "./profile-view";
import serviceProvider from '../../services/axios'
import "./profile.scss";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { Helmet } from "react-helmet";
export const PurchaseController = (props) => {
	const [results, setResults] = useState([]);
	const [onTab, setOnTab] = useState(1);
	const user = JSON.parse(localStorage.getItem("userData"));
	const usid = user ? user.uid : 0;
	useEffect(() => {
		props.handleExpandFal();
		const search = async () => {
			const apiUrl = `/profile?param=purchase&uid=${usid}`;
			const { data } = await serviceProvider.get(apiUrl,true,{});
			setResults(data);
		};
		search();
	}, []);
	return (
		<>
			<Helmet>
				<title>Purchase History | SmarterChains</title>
				<meta name="description" content="Purchase History" />
			</Helmet>
			<BreadcrumbsItem to="/">Home</BreadcrumbsItem>
			<BreadcrumbsItem to="/profile">Account Settings</BreadcrumbsItem>
			<ProfileView onTab={onTab} profileData={results} {...props} />
		</>
	);
};
